import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import LocationSearchInputContext from '@justpark/ui/src/components/LocationSearchInput/LocationSearchInputContext';
import Heart from '@justpark/ui/src/components/FontAwesome/Heart';
import HeartOutline from '@justpark/ui/src/components/FontAwesome/HeartOutline';
import { show as showSnackbar } from '@justpark/snackbar/src/reducers/snackbar';
import handleFamiliarSpaces from '../../helpers/handleFamiliarSpaces';
import SearchFormList from './SearchFormList';
import { ampli } from '../../helpers/Tracking/amplitude';

import styles from '../../../static/scss/components/favouriteSpaces.module.scss';

type Props = {
  setSearchData: () => void,
  favourites: Array<any>,
  setFavourites: () => void,
  recentSearches: Array<any>,
  setRecentSearches: () => void
};

const FavouriteSearches = ({
  setSearchData,
  favourites,
  setFavourites,
  recentSearches,
  setRecentSearches
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const setShowResultsContainer = useContext(LocationSearchInputContext);

  const handleFamiliarSpacesClick = (result) => {
    setShowResultsContainer(false);
    setSearchData((existingData) => ({
      ...existingData,
      ...result
    }));

    ampli.favouriteSearchClicked();
  };

  const handleFavouriteSearchesIconClick = (e, result) => {
    e.stopPropagation();

    const newFavourites = favourites.filter(
      (item) =>
        item.searchData.googlePlaceId !== result.searchData.googlePlaceId
    );

    setFavourites(newFavourites);

    ampli.favouriteRemoved();
    ampli.identify(undefined, {
      favourite_search_count: newFavourites.length
    });
  };

  const handleRecentSearchesIconClick = (e, result) => {
    e.stopPropagation();

    const newFavourites = handleFamiliarSpaces(favourites, result);
    setFavourites(newFavourites);

    setRecentSearches(
      recentSearches.filter(
        (item) =>
          item.searchData.googlePlaceId !== result.searchData.googlePlaceId
      )
    );

    dispatch(
      showSnackbar(
        t(
          'homePage:addedToFavourites',
          { location: result.query },
          `Added ${result.query} to favourites`
        )
      )
    );

    ampli.favouriteAdded();
    ampli.identify(undefined, {
      favourite_item_count: newFavourites.length
    });
  };

  return (
    <>
      <SearchFormList
        heading={t('homePage:favouriteSearches', 'Favourite searches')}
        name="favourite-searches"
        list={favourites}
        onClick={handleFamiliarSpacesClick}
        iconSlotComponent={<Heart className={styles.heart} />}
        onClickIconSlotComponent={handleFavouriteSearchesIconClick}
      />
      <SearchFormList
        heading={t('homePage:recentSearches', 'Recent searches')}
        name="recent-searches"
        list={recentSearches}
        onClick={handleFamiliarSpacesClick}
        iconSlotComponent={<HeartOutline className={styles.heartOutline} />}
        onClickIconSlotComponent={handleRecentSearchesIconClick}
      />
    </>
  );
};

export default FavouriteSearches;
